import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const wixStyleReactProviderDriverFactory = (base, body) => {
  return {
    ...baseUniDriverFactory(base, body),
  };
};
